import React from "react";
import SubscriptionTermsandconditions from "../../components/T&C/SubscriptionTermsandconditions";
import Layout from "../../components/Layout/Layout";

const SubscriptionTermsandcondition = () => {
  return (
    <div>
      <Layout>
        <SubscriptionTermsandconditions />
      </Layout>
    </div>
  );
};

export default SubscriptionTermsandcondition;
